<template>
  <MyAccountCheckAuthLoggedIn>
    <MyAccountPlacesGrid />
  </MyAccountCheckAuthLoggedIn>
</template>

<script setup lang="ts">
const { url } = useDomainHost()

const { t } = useI18n()

const { store } = useDomainState()

useServerSeoMeta(
  useOgMeta(
    url + '/my-account/places',
    t('saved_places'),
    store.value?.about,
    store.value?.thumb
  )
)

useHead({
  title: t('saved_places'),
  meta: [
    { hid: 'description', name: 'description', content: store.value?.about }
  ],
  link: [useSeoCanonical(url + '/my-account/places')],
  script: [
    useSeoBreadcrumb([
      useSeoBreadcrumbItem(1, t('home'), url),
      useSeoBreadcrumbItem(2, t('profile'), url + '/my-account'),
      useSeoBreadcrumbItem(3, t('saved_places'), url + '/my-account/places')
    ])
  ]
})
</script>
